export default (that) => [
  {
    field: 'seq',
    width: 60,
    fixed: 'left',
    align: 'center',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    field: 'displayImage',
    title: that.$l('INDEX.table_label_image') || '图片',
    width: 120,
    align: 'center',
    fixed: 'left',
    slots: { default: 'displayImage' },
  },
  {
    title: that.$l('table_label_fabric_request_no') || '开发单号',
    field: 'fabricRequestNo',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_request_status') || '状态',
    field: 'fabricStatus',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'status' },
  },
  {
    title: that.$l('table_label_stock_status') || '入库状态',
    field: 'isInStock',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'isInStock' },
  },
  {
    title: that.$l('form_label_bill_name') || '业务员',
    field: 'fabricAgentName',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('INDEX.label_customer') || '客户',
    field: 'custName',
    width: 220,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fabric_no') || '面料编号',
    field: 'fabricNo',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_fabric_name') || '面料名称',
    field: 'fabricName',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_wid_and_weight') || '门幅克重',
    field: 'widAndWeight',
    minWidth: 130,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'widAndWeight' },
  },
  {
    title: that.$l('form_label_unitPrice') || '单价',
    field: 'priceInfo',
    minWidth: 150,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'priceInfo' },
  },
  {
    title: that.$l('table_label_fabric_composition') || '面料成分',
    field: 'fabricContent',
    minWidth: 300,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('form_label_supplier') || '供应商',
    field: 'scmName',
    minWidth: 250,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_factory_number') || '工厂面料编号',
    field: 'factoryNumber',
    minWidth: 180,
    align: 'left',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || 'Create',
    field: 'createInfo',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || 'Modify',
    field: 'modifyInfo',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
]
